import { MessageSquare } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function SmsSettingsPage() {
  return (
    <PlaceholderPage
      icon={MessageSquare}
      title="Konfiguracja SMS"
      description="Skonfiguruj bramk\u0119 SMS, numery nadawcze i szablony wiadomo\u015Bci tekstowych."
    />
  )
}
